import React from 'react'
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@hub/accordion'
import { Text } from '@hub/text'
import { Link } from '@hub/link'
import { Stack } from '@hub/stack'
import { Item } from '../types'

interface PaneAccordionProps {
  itemTitle: string
  items: Item[]
}

export const PaneAccordion: React.FC<PaneAccordionProps> = ({
  itemTitle,
  items,
}) => (
  <AccordionItem
    sx={{
      border: 'none',
      paddingY: 'spacing-sm',
      width: 'size-full',
    }}
  >
    <AccordionButton sx={{ padding: 0, margin: 0 }}>
      <Text tone="strong" fontSize="font-lg" align="left" sx={{ flex: 1 }}>
        {itemTitle}
      </Text>
      <AccordionIcon />
    </AccordionButton>
    <AccordionPanel>
      <Stack
        gap="spacing-md"
        sx={{
          paddingX: 'spacing-md',
          paddingTop: 'spacing-md',
          fontSize: 'font-sm',
          lineHeight: '16px',
        }}
      >
        {items &&
          items.map((item, i) => {
            if (!item || !('url' in item)) {
              return null
            }
            return (
              <Link
                to={item.url}
                href={item.url}
                key={i}
                onClick={item.onClick}
              >
                {item.label}
              </Link>
            )
          })}
      </Stack>
    </AccordionPanel>
  </AccordionItem>
)
